import React from "react";
import Loader from "./Loader";
import Error from "./Error";
import { useGetTennisMatchesQuery } from "../../store/services/mainApi";
const TenisList = () => {
  const { data, isFetching, error } = useGetTennisMatchesQuery();
  if (isFetching) {
    return <Loader />;
  }
  if (error) {
    return <Error />;
  }

console.log(data);

return (
  <div>
    {data.map((ele, i) => {
      return (
        <div className="inner_inplay px-3 py-2  text-sm bg-[#ffff]">
          <span className="text-[#243a48] font-bold">2023-04-05</span>
          <span>
            <a
              href=""
              className="hover:underline text-[#2789ce] font-bold mx-2"
            >
              {ele?.ename}
            </a>
          </span>
        </div>
      );
    })}
  </div>
);
};

export default TenisList;
